'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var pathSelector = exports.pathSelector = function pathSelector(state) {
  return state.request.path;
};
var querySelector = exports.querySelector = function querySelector(state) {
  return state.request.query;
};
var fullPathSelector = exports.fullPathSelector = function fullPathSelector(state) {
  var _state$request = state.request,
      currentFullUrl = _state$request.currentFullUrl,
      hostname = _state$request.hostname;


  return currentFullUrl.replace(new RegExp('^https?://' + hostname + '(:\\d+)?/'), '/');
};